<template>
  <container-app style="padding: 0px 0px">
    <header-app
      to="home"
      :title="$t('orders')"
      class="header-brand"
    ></header-app>
    <wrap style="padding-top: 55px">
      <loading-location v-if="loading === true"></loading-location>
      <div class="">
        <!-- :style="`background-image: url(${require('@/assets/sale/bg_top.svg')});   
          background-repeat: no-repeat;`" -->
        <div class="order_detail" v-if="order.id">
          <div class="header bg-brand text-white mb-2">
            <h6>{{ $t("Order Information") }}</h6>
            <p>TRANSACTION #{{ order.id }}</p>
            <p>
              <span
                class="badge badge-sm badge-success check_paid"
                v-if="order.is_paid == 'YES'"
              >
                <base-icon icon_name="check" />
              </span>
              {{ $t("Paid") }} : {{ $t(order.is_paid) }}
            </p>
            <p>{{ $t("Status") }} : {{ $t(order.status) }}</p>
          </div>
          <div
            class="text-white"
            style="float: right; margin-right: 7px; margin-top: -39px"
          >
            <p>{{ $t(order.type_title) }}</p>
            <!-- {{ $t("Place") }} : -->
          </div>
          <div class="mb-4">
            <h3 align="center" class="header">
              {{ order.hotel_name }}
            </h3>
            <p>{{ $t("Time") }} : {{ order.created_at | formatDate }}</p>
            <p>{{ $t("OrderType") }} : {{ $t(order.order_type) }}</p>
            <!-- <p>{{ $t("Status") }} : {{ $t(order.status) }}</p> -->
          </div>
          <table class="table table-sm table-borderless table-striped">
            <thead>
              <tr>
                <th>{{ $t("Description") }}</th>
                <th class="text-center">QTY</th>
                <th class="text-right">{{ $t("Amount") }}</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in order.sale_details" :key="index">
                <td class="text-left no_border">
                  {{ item.venueitem_name }}
                  <p
                    v-for="op in item.options"
                    :key="op.id"
                    class="item-description pl-3"
                    style="font-size: 15px; line-height: 35px; color: #6c757d"
                  >
                    {{ op.title }} :
                    <template v-for="opl in op.option_optionvalue"
                      >{{ opl.optionvalue_title }}
                    </template>
                  </p>

                  <p v-if="item.note">
                    <span class="text-success"> * {{ item.note }}</span>
                  </p>
                </td>
                <td class="text-center">
                  <p>{{ item.qty }}</p>
                </td>
                <td class="no_border text-right">
                  {{ currencyFormat(item.price) }}
                </td>
              </tr>

              <tr>
                <td>{{ $t("discount") }}</td>
                <td></td>
                <td class="no_border text-right">
                  {{ currencyFormat(order.discount) }}
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table table-sm table-borderless">
            <tbody class="tbody">
              <tr>
                <td class="text-right no_border" colspan="1">
                  {{ $t("Total") }} :
                </td>
                <td class="text-right no_border" colspan="1">
                  {{ formatExchange(order.sub_total, base_currency) }}
                </td>
              </tr>

              <tr>
                <td class="text-right no_border" colspan="1">
                  {{ $t("Delivery Fee") }} :
                </td>
                <td class="text-right no_border">
                  {{ formatExchange(order.delivery_fee, base_currency) }}
                </td>
              </tr>

              <tr>
                <td class="text-right no_border" colspan="1">
                  {{ order.service_charge_percentage }} %
                  {{ $t("Service Charge") }}:
                </td>
                <td class="text-right no_border">
                  {{
                    formatExchange(order.service_charge_amount, base_currency)
                  }}
                </td>
              </tr>
              <template v-if="order.tax_type == 'EXCLUSIVE'">
                <tr>
                  <td class="text-right no_border" colspan="1">
                    {{ order.tax_percentage }} % Tax:
                  </td>
                  <td class="text-right no_border">
                    {{ formatExchange(order.tax_amount, base_currency) }}
                  </td>
                </tr>
              </template>

              <template v-else>
                <tr>
                  <td class="text-right no_border" colspan="1">
                    Inc. {{ order.tax_percentage }} % Tax:
                  </td>
                  <td class="text-right no_border">
                    {{ formatExchange(order.tax_amount, base_currency) }}
                  </td>
                </tr>
              </template>
            </tbody>
            <tr>
              <th class="text-right no_border">
                <p>{{ $t("Amount to be Paid") }}</p>
              </th>
              <th class="text-right no_border">
                <p>
                  {{ formatExchange(order.amount_to_be_paid, base_currency) }}
                </p>
              </th>
            </tr>
            <tr v-for="(rate, index) in exchange_rates" :key="index">
              <td class="text-right no_border"></td>
              <td class="text-right no_border">
                {{ formatExchange(order.amount_to_be_paid, rate) }}
              </td>
            </tr>

            <tr>
              <td>
                <!-- {{ $t("Inc") }}. {{ order.service_charge || 0 }} %
                {{ $t("Service Charge") }} : -->
              </td>
              <td></td>
            </tr>
          </table>
          <div class="">
            <p>{{ $t("ItemCount") }} : {{ totalItemCount }}</p>
            <p>{{ $t("Note") }}: {{ order.note }}</p>
          </div>

          <div class="text-center">
            <p class="quoted">Thank you for your order !</p>
            <p>www.discoverlaos.today</p>
          </div>

          <div class="">
            <button
              class="btn btn-block btn-primary mt-3"
              @click="$router.push({ name: 'province' }).catch((err) => {})"
            >
              {{ $t("Back to order!") }}
            </button>
          </div>
        </div>
        <div v-if="loading === false && !order.id" class="text-center">
          {{ $t("Receipt is not found!") }}
          <button
            class="btn btn-block btn-primary mt-5"
            @click="$router.push({ name: 'province' }).catch((err) => {})"
          >
            {{ $t("Back to order!") }}
          </button>
        </div>
      </div>
    </wrap>
  </container-app>
</template>
<style lang="css">
.bg-brand {
  background: #5d179d;
}

.order_detail {
  margin: auto;
  max-width: 500px;
  background: white;
  padding: 10px;
}

.check_paid {
  border-radius: 26px;
  font-size: 1px;
}
.header {
  font-size: 15px;
}
</style>
<script>
import store from "@/store";
export default {
  name: "OrderDetail",
  middleware: ["auth"],
  data: () => ({
    orderId: 0,
    exchange_rates: [],
    base_currency: {},
  }),
  mounted() {
    this.orderId = this.$route.params.orderId;
    this.getOrder();
  },
  computed: {
    order() {
      return store.getters["orders/order"] || {};
    },
    loading() {
      return store.getters["orders/loading_order"] || {};
    },
    totalItemCount() {
      let qty = 0;
      _.forEach(this.order.sale_details, function (item) {
        qty += item.qty;
      });
      return qty;
    },
  },
  methods: {
    get_base_currency() {
      let vm = this;
      this.exchange_rates = JSON.parse(this.order.all_exchangerate);
      this.exchange_rates.forEach(function (rate) {
        if (rate.default === true) {
          vm.base_currency = rate;
        }
      });
      let index = this.exchange_rates.findIndex((rate) => {
        return rate.code === vm.base_currency.code;
      });
      this.exchange_rates.splice(index, 1);
    },
    async getOrder() {
      await store.dispatch("orders/getOrderDetail", this.orderId);
      if (this.order.id) this.get_base_currency();
    },
    formatExchange(value, rate) {
      let val = ((value * rate.rate) / 1).toFixed(2).replace(".", ".");
      return (
        rate.code + "  " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    currencyFormat(value) {
      let val = ((value * 1) / 1).toFixed(2).replace(".", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>